import React from "react";
import DynamicTable from "../../widgets/dynamicTable/DynamicTable";
import HelperMetiers360 from "../../../services/HelpersMetiers360";
import { useStoreState } from 'easy-peasy';

const OrderLinesTableComponent = ({
    orderLines
}) => {
  
    const { apiData: { BACKOFFICE_DEFAULT_VALUES } } = useStoreState(state => state.actionSlugs);
    const { typeOfHeadset: allHeadsetsTypes } = BACKOFFICE_DEFAULT_VALUES;


    const sortType = orderLines?.length > 0 ?
    [
        {
            value : 'name', label : 'Nom',
            test : HelperMetiers360.isArrayContainsValue(orderLines, "name"),
            method : (a, b) => HelperMetiers360.localeCompareWithNullable(a.name, b.name),
            display: (product) => product.name? product.name : '-'
        },
        {
                value: 'reference', label: 'Casque inclus',
                test: HelperMetiers360.isArrayContainsField(orderLines, "reference"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.reference, b.reference),
                display: (product) => product?.reference
                    ? (allHeadsetsTypes?.find(t => t.reference == product.reference)?.label ?? product.reference)
                    : '-'
            },
            {
            value : 'quantity', label : 'Quantité',
            test : HelperMetiers360.isArrayContainsValue(orderLines, "quantity"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.quantity, b.quantity),
            display: (product) => product.quantity  ? product.quantity : '-'
        }
    ]
    :null;

    return sortType && <DynamicTable
        contentTable = {orderLines}
        contentSort = {sortType}
        valueInitSort = "name"
        index = 'uniqueId'
        filename="contenu_bon" />;
};

export default OrderLinesTableComponent;